import { AdminExamCourseEnablementButton } from '@exam-center/admin-exam-course-enablement';
import { AdminExamCourseList } from '@exam-center/admin-exam-course-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Paper, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamCoursesPage() {
  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_COURSE_MANAGEMENT.SETTINGS.VIEW}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          height: '100dvh',
          bgcolor: (theme) => theme.palette.grey[50],
        }}
      >
        <Flex
          sx={{
            justifyContent: 'space-between',
            p: (theme) => theme.spacing(8, 6),
            alignItems: 'center',
          }}
        >
          <Text variant='h1'>จัดการหลักสูตร</Text>
          <AdminExamCourseEnablementButton />
        </Flex>
        <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1 }}>
          <Paper sx={{ width: '100%', borderRadius: (theme) => theme.shape.rounded(2) }}>
            <Flex
              sx={(theme) => ({
                flexDirection: 'column',
                height: '100%',
                gap: theme.spacing(6),
                p: theme.spacing(6),
              })}
            >
              <AdminExamCourseList />
            </Flex>
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
